'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _classNames = require('react-utils/classNames');

var _classNames2 = _interopRequireDefault(_classNames);

var _Constants = require('ui-addon-avatars/Constants');

var _UIAvatar = require('ui-addon-avatars/UIAvatar');

var _UIAvatar2 = _interopRequireDefault(_UIAvatar);

var _Images = require('../visitor-widget/constants/Images');

var _AvatarSize = require('../visitor-widget/constants/AvatarSize');

var _AvatarSize2 = _interopRequireDefault(_AvatarSize);

var _StatusIndicator = require('./StatusIndicator');

var _StatusIndicator2 = _interopRequireDefault(_StatusIndicator);

var _RecordPropType = require('conversations-prop-types/prop-types/RecordPropType');

var _RecordPropType2 = _interopRequireDefault(_RecordPropType);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _react2.default.createClass({
  displayName: 'ChatHead',

  propTypes: {
    avatar: _react.PropTypes.string,
    away: _react.PropTypes.bool.isRequired,
    className: _react.PropTypes.string,
    disabled: _react.PropTypes.bool,
    isBot: _react.PropTypes.bool,
    isVisitorWidget: _react.PropTypes.bool.isRequired,
    onClick: _react.PropTypes.func,
    online: _react.PropTypes.bool.isRequired,
    responder: (0, _RecordPropType2.default)('Responder'),
    showStatus: _react.PropTypes.bool.isRequired,
    size: _react.PropTypes.string.isRequired,
    style: _react.PropTypes.object
  },

  getDefaultProps: function getDefaultProps() {
    return {
      avatar: _Constants.DEFAULT_CONTACT_AVATAR,
      away: false,
      disabled: false,
      online: false,
      showStatus: false,
      isVisitorWidget: false,
      size: _AvatarSize2.default.MEDIUM
    };
  },
  renderStatus: function renderStatus() {
    var _props = this.props,
        online = _props.online,
        away = _props.away,
        size = _props.size,
        responder = _props.responder,
        isVisitorWidget = _props.isVisitorWidget;


    if (responder) {
      return _react2.default.createElement(_StatusIndicator2.default, {
        responder: responder,
        size: size,
        isVisitorWidget: isVisitorWidget
      });
    }

    var className = (0, _classNames2.default)('chat-head-icon chat-head-status ' + size, {
      away: away,
      offline: !online,
      online: online && !away
    });

    return _react2.default.createElement('div', { className: className });
  },
  renderAvatar: function renderAvatar() {
    var _props2 = this.props,
        avatar = _props2.avatar,
        style = _props2.style,
        size = _props2.size,
        isBot = _props2.isBot;


    var avatarSrc = avatar;

    if (avatar === null && isBot) {
      avatarSrc = _Images.mrHubBot;
    }

    return _react2.default.createElement(_UIAvatar2.default, {
      style: style,
      src: avatarSrc,
      className: 'chat-head-avatar',
      size: size,
      type: 'contact'
    });
  },
  render: function render() {
    var _props3 = this.props,
        onClick = _props3.onClick,
        className = _props3.className,
        showStatus = _props3.showStatus,
        disabled = _props3.disabled;


    var classes = (0, _classNames2.default)('chat-head', { 'chat-head-disabled': disabled }, className);
    return _react2.default.createElement(
      'div',
      { className: classes, onClick: onClick },
      this.renderAvatar(),
      showStatus && this.renderStatus()
    );
  }
});
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/conversations-internal-components/static-1.4266/js/visitor-widget/ChatHead.js
// module id = 481
// module chunks = 2 3